import { TinyColor, isReadable } from '@ctrl/tinycolor';

export const transparentize = (color: string, opacity: number) =>
  new TinyColor(color).setAlpha(opacity).toRgbString();

export const lighten = (color: string, amount: number) =>
  new TinyColor(color).lighten(amount).toRgbString();

export const darken = (color: string, amount: number) =>
  new TinyColor(color).darken(amount).toRgbString();

export function computeForegroundColor(backgroundColor: string) {
  if (isReadable('#f9fafb', backgroundColor, { level: 'AA', size: 'large' })) {
    return '#f9fafb';
  }
  return '#1f2937';
}
